module.exports = __webpack_public_path__ + "40588152d2da8fb4f3c7b050b964a3f4.svg";